<template>
  <section class="collapsible-section flex flex-col">
    <button
      v-if="headerLabel"
      :disabled="disabled"
      :class="[accentColor, isExpanded ? 'rounded-t-lg' : 'rounded-lg']"
      class="collapsible-section__header w-full flex justify-between items-center px-3 py-2 rounded-t-lg duration-[35ms]"
      @click.prevent="
        () => {
          toggle()
          $emit('onToggle', isExpanded)
        }
      "
    >
      <h3 class="text-white text-start capitalize">{{ headerLabel || 'no header' }}</h3>
      <slot name="header-end">
        <div v-if="!disabled" class="text-white font-bold">
          <span v-if="isExpanded">&minus;</span>
          <span v-else>&plus;</span>
        </div>
      </slot>
    </button>
    <div
      :class="[
        isExpanded ? 'h-[unset] px-4 py-3 border' : 'h-0 p-0 border-none',
        !headerLabel ? 'rounded-lg' : 'rounded-b-lg',
        bodyClass,
        borderColor
      ]"
      class="collapsible-section__body duration-75 overflow-hidden bg-white"
    >
      <slot> </slot>
    </div>
  </section>
</template>

<script setup>
import { useToggle } from '@vueuse/core'

const props = defineProps({
  headerLabel: String,
  accentColor: {
    type: String,
    default: () => 'bg-primary'
  },
  borderColor: {
    type: String,
    default: () => 'border-primary'
  },
  bodyClass: String,
  disabled: {
    type: Boolean,
    default: false
  },
  initialExpandedState: {
    type: Boolean,
    default: () => true
  }
})

const [isExpanded, toggle] = useToggle(props.initialExpandedState ?? true)

defineExpose({ toggle, isExpanded })
</script>

<style lang="scss" scoped></style>
